import util from '../util'

let controller = 'SaldoBloqueado'
export default Object.assign({}, util.GetCrud(controller, null),
  {
    GetByConta: function (dto) {
      return util.Axios.GetAll(controller + '/GetByConta', dto)
    },
    GetByContaAutomatico: function (dto, options) {
      if (options && options.data) dto.data = options.data
      return util.Axios.GetAll(controller + '/ListarSaldoBloqueadoAutomatico', dto)
    }
  })
